import React from "react";
import {Button, TextareaItem, List, Toast, WhiteSpace} from 'antd-mobile';
import MobileWrapper from '../../layouts/MobileWrapper';
import OvertimeApprovalService from "../../services/Approval/overtime-approval-service";
import DayoffApprovalService from "../../services/Approval/dayoff-approval-service";
import LeaveApprovalService from "../../services/Approval/leave-approval-service";
import GooutApprovalService from "../../services/Approval/goout-approval-service";
import BusinessApprovalService from "../../services/Approval/business-approval-service";
import ComplainApprovalService from "../../services/Approval/complain-approval-service";
import {push} from 'react-router-redux';
import {store} from '../../store/store';
import './style.css';


class MobileApprovalContent  extends React.Component  {


    constructor(props) {
        super(props)


        this.state = {
            data: props.fatherProps.location.state,
            remark: ""
        }

    }



    approval =  (id, approval_status)  => {

        let params = {
            id: id,
            approval_status:approval_status,
            complaint_content:this.state.remark
        }



        if(this.state.data.approvalType === "overtime" ){

            OvertimeApprovalService.updateOvertimeApproval(params, res => {
                if (res.data.Success) {
                    Toast.success("审批成功", 4);


                    store.dispatch(push(this.state.data.historyPath))


                } else {
                    Toast.fail(`审批失败：${res.data.Errors}`,4);
                }
            }, err => {
            });

        }



        if(this.state.data.approvalType === "dayoff" ){

            DayoffApprovalService.updateDayoffApproval(params, res => {
                if (res.data.Success) {
                    Toast.success("审批成功", 4);


                    store.dispatch(push(this.state.data.historyPath))


                } else {
                    Toast.fail(`审批失败：${res.data.Errors}`,4);
                }
            }, err => {
            });

        }


        if(this.state.data.approvalType === "leave" ){

            LeaveApprovalService.updateLeaveApproval(params, res => {
                if (res.data.Success) {
                    Toast.success("审批成功", 4);


                    store.dispatch(push(this.state.data.historyPath))


                } else {
                    Toast.fail(`审批失败：${res.data.Errors}`,4);
                }
            }, err => {
            });

        }


        if(this.state.data.approvalType === "goout" ){

            GooutApprovalService.updateApproval(params, res => {
                if (res.data.Success) {
                    Toast.success("审批成功", 4);


                    store.dispatch(push(this.state.data.historyPath))


                } else {
                    Toast.fail(`审批失败：${res.data.Errors}`,4);
                }
            }, err => {
            });

        }


        if(this.state.data.approvalType === "business" ){

            BusinessApprovalService.updateBusinessApproval(params, res => {
                if (res.data.Success) {
                    Toast.success("审批成功", 4);


                    store.dispatch(push(this.state.data.historyPath))


                } else {
                    Toast.fail(`审批失败：${res.data.Errors}`,4);
                }
            }, err => {
            });

        }



        if(this.state.data.approvalType === "complain" ){

            ComplainApprovalService.updateComplainApproval(params, res => {
                if (res.data.Success) {
                    Toast.success("审批成功", 4);


                    store.dispatch(push(this.state.data.historyPath))


                } else {
                    Toast.fail(`审批失败：${res.data.Errors}`,4);
                }
            }, err => {
            });

        }
    }

    handleChange = (event) => {

        this.setState({remark: event});
    }


    render() {

        return <form>
            <List style={{backgroundColor: 'white'}} className="picker-list">

                <TextareaItem
                    title="审批意见"
                    placeholder="审批意见"
                    value={this.state.remark}
                    rows={5}
                    onChange={this.handleChange}

                />



            </List>
            <WhiteSpace />
            <WhiteSpace />
            <WhiteSpace />

            <div
                style={{width: '100%', color: '#108ee9', textAlign: 'center'}}
                onClick={this.onSubmit}
            >
                {
                    !!this.state.data.status &&

                    <Button onClick={(e) => this.approval(this.state.data.id, 1)} type="primary">通过</Button>
                }

                {
                    !this.state.data.status &&

                    <Button onClick={(e) => this.approval(this.state.data.id, 2)} type="warning">驳回</Button>
                }

            </div>
        </form>
    }
}

export default MobileWrapper(MobileApprovalContent);




// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileApprovalContent.js